import { render, staticRenderFns } from "./Statistic.html?vue&type=template&id=19fed7aa&external"
import script from "./Statistic.js?vue&type=script&lang=js&external"
export * from "./Statistic.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports